export const getEducationalCaseViewerUrl = (item) => {
  if (item.itemType === "PRESENTATION_SLIDE") return "";

  // Educational material APIs expose system_case_number as caseNumber.
  const caseSystemNumber = String(
    item.caseSystemNumber || item.systemCaseNumber || item.caseNumber || "",
  ).trim();
  if (!caseSystemNumber) return "";

  const environment = process.env.VUE_APP_ENVIRONMENT;
  const baseUrl =
    environment === "Prod" || environment === "Production"
      ? "https://www.worldtumorregistry.org"
      : environment === "Development"
      ? "https://dev-public-wtrsite.pathpresenter.net"
      : environment === "Staging"
      ? "https://staging-public-wtrsite.pathpresenter.net"
      : "http://localhost:3000";

  // Keep the mapping used by educational_assignment_answer.html.
  const tumorSite = String(
    (item.tumorSite && item.tumorSite.name) || item.tumorSite || "",
  ).toLowerCase();
  const tumorId = tumorSite.includes("thyroid") || tumorSite.includes("tyroid")
    ? 1
    : tumorSite.includes("breast") ? 2 : tumorSite.includes("lung") ? 3 : 1;

  return `${baseUrl}/search-result?tumorId=${tumorId}&caseSystemNumber=${encodeURIComponent(caseSystemNumber)}`;
};
